import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const timers = {};

export async function fetchToolData(key, token) {
  if (!token) return null;
  try {
    const r = await axios.get(`${API}/member/tooldata/${key}`, { headers: { Authorization: `Bearer ${token}` } });
    return r.data?.data ?? null;
  } catch {
    return null;
  }
}

export function saveToolData(key, token, data) {
  if (!token) return;
  clearTimeout(timers[key]);
  timers[key] = setTimeout(() => {
    axios.put(`${API}/member/tooldata/${key}`, { data }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
  }, 700);
}

export const davetliKey = (mid) => `dugun_davetli_v1${mid ? "_" + mid : ""}`;
